import { connect } from 'react-redux';
import { getExportSsoErrors, clearDownloadSsoDataErrors, downloadSsoData } from 'src/reducers/employees/employeePays';
import ExportSsoModal from '../components/ExportSsoModal';
import { FORM_NAME_PAYS_SEARCH, takePaymentRangeFormSearchForm } from 'src/reducers/searchForm';

const mapStateToProps = state => ({
  paymentRange: takePaymentRangeFormSearchForm(state, FORM_NAME_PAYS_SEARCH),
  errors: getExportSsoErrors(state)
});
const mapDispatchToProps = dispatch => ({
  onModalHide: () => dispatch(clearDownloadSsoDataErrors()),
  handleSubmit: (data, paymentRange) => {
    dispatch(downloadSsoData({ ...data, ...paymentRange }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportSsoModal);